<template>
	<AppHeader
		:logo="logo"
		:headerButton1="headerButton1"
		:headerButton2="headerButton2"
	/>

	<div class="flex-grow-1">
		<UiElement class="d-flex flex-column h-100 py-0" :settings="appearance.body.settings">
			<UiText :settings="text1" class="text-center">
				3/3
			</UiText>

			<UiText :settings="heading1" class="text-center">
				{{ translations?.payment || '{payment}' }}
			</UiText>

			<div class="d-flex flex-column align-items-center justify-content-center flex-grow-1">
				<UiText :settings="heading1" class="text-center">
					{{ translations?.paymentTitle || '{paymentTitle}' }}
				</UiText>

				<div class="py-5 my-5">
					<img src="https://cdn-icons-png.flaticon.com/512/61/61932.png" alt="" width="162" />
				</div>

				<div class="w-100">
					<UiProgress :settings="general.elements.progress1.settings" :progress="50" />
				</div>
			</div>
		</UiElement>
	</div>
</template>

<script setup>
	import { computed } from 'vue';
	import { storeToRefs } from 'pinia';
	import { useThemeStore } from '@/stores/useThemeStore';
	import UiElement from '@/components/UI/UiElement.vue';
	import UiText from '@/components/UI/UiText.vue';
	import UiProgress from '@/components/UI/UiProgress.vue';
	import AppHeader from '@/components/AppHeader.vue';
	import { useInheritedSettings } from '@/composables/useInheritedSettings';
	import { useTranslationsStore } from '@/stores/useTranslationsStore';

	const themeStore = useThemeStore();
	const translationsStore = useTranslationsStore();

	const { theme } = storeToRefs(themeStore);
	const { translations } = storeToRefs(translationsStore);

	const general = computed(() => theme.value.general);
	const page = computed(() => theme.value.pages.payment);
	const appearance = computed(() => page.value.appearance);
	const elements = computed(() => page.value.elements);

	const text1 = useInheritedSettings(computed(() => elements.value?.text1));
	const heading1 = useInheritedSettings(computed(() => elements.value?.heading1));

	const logo = useInheritedSettings(computed(() => elements.value?.logo));
	const headerButton1 = useInheritedSettings(computed(() => elements.value?.headerButton1));
	const headerButton2 = useInheritedSettings(computed(() => elements.value?.headerButton2));
</script>